// import Swiper JS
import Swiper from 'swiper';
import {Navigation, Pagination, Grid} from 'swiper/modules';

// import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';

window.addEventListener('load', ()=> {
    initSlider();
});

window.addEventListener('orientationchange', ()=> {
    initSlider();
})

function initSlider() {
    const wrapperSwiper = document.querySelector('.articles-grid-block');

    if (wrapperSwiper) {
        const swiperElement = wrapperSwiper.querySelector('.swiper');
        const buttonPrev = wrapperSwiper.querySelector('.swiper-button-prev');
        const buttonNext = wrapperSwiper.querySelector('.swiper-button-next');
    
        const slider = new Swiper(swiperElement, {
            modules: [Navigation, Pagination, Grid],
            slidesPerView: 1,
            spaceBetween: 0,
            // observer: true,
            // observeParents: true,
            // centerInsufficientSlides: true,
            // autoHeight: true,
            // centeredSlides: true,
            // initialSlide: 2,
            breakpoints: {
                650: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                    grid: {
                        rows: 2,
                    },
                },
            },

            grid: {
                rows: 1,
            },
    
            navigation: {
                prevEl: buttonPrev,
                nextEl: buttonNext,
            },
    
            // pagination: {
            //     el: ".swiper-pagination",
            //     // clickable: true,
            //     dynamicBullets: true,
            //     // dynamicMainBullets: 3,
            // },
        });
    
        slider;    
    }
}
